import { render, staticRenderFns } from "./CbsFileUpload.vue?vue&type=template&id=53a56aa4&scoped=true"
import script from "./CbsFileUpload.vue?vue&type=script&lang=js"
export * from "./CbsFileUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a56aa4",
  null
  
)

export default component.exports